/**
 * Iframe remount key for agent sessions.
 * Cookie refresh alone does not update in-memory auth inside the iframe,
 * so consumers remount when `refreshNonce` bumps after a successful mint.
 */
export const buildAgentIframeKey = (
  organizationId: string,
  refreshNonce: number
): string => `${organizationId}-${refreshNonce}`;
